export default "__VITE_ASSET__4de1ccb2__"